<template>
  <div class="">
    <div class="card">
      <div class="header">
        <h2>OAuth v2 Endpoint 설정 추가</h2>
        <p>당신의 API를 위한 인증 URL을 추가하세요.</p>
      </div>
      <div>
        <!-- Select -->
        <div class="row clearfix">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <dev-auth-input-two-modes v-bind:requestIndex="0" />

            <!-- <div class="card">
                                <div class="header">
                                    <h2> <strong>Scope (optional)</strong>  </h2>
                                    
                                </div>
                                <div class="body" id="formModer"  >
                                    <div class="row clearfix">
                                        <div class="col-sm-12">
                                            <div class="form-group">                                    
                                                <input type="text" class="form-control" placeholder="Enter the field's friendly name for users" />
                                            </div>
                                        </div>
                                        
                                    </div>
                
                                </div>

                            </div> -->

            <dev-auth-input-two-modes v-bind:requestIndex="1" />
            <dev-auth-input-two-modes v-bind:requestIndex="2" />
            <dev-auth-input-two-modes v-bind:requestIndex="3" />

            <!-- <dev-auth-connection-label /> -->
          </div>
        </div>
        <!-- #END# Select -->
      </div>

      <div style="text-align: right; margin-bottom: 10px; margin-right: 10px">
        <!-- <router-link to="/developer/app/authentication/fields"><button class="btn btn-default">Add Fields</button></router-link> -->
        <button type="button" class="btn btn-primary" @click="submitBtn">
          저장 후 계속
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import eventbus from "@/store/modules/devEventBus";

import DevAuthInputTwoModes from "@/views/dev/auth/DevAuthInputTwoModes";
// import { install } from 'vuex';
// import DevAuthConnectionLabel from '@/views/dev/auth/DevAuthConnectionLabel'

export default {
  components: {
    // 'DevAuthConnectionLabel' : DevAuthConnectionLabel,
    DevAuthInputTwoModes: DevAuthInputTwoModes,
  },

  data() {
    return {
      twoStatus: false,
      formStatus0: true,
      codeStatus0: false,
      formStatus1: true,
      codeStatus1: false,
      formStatus2: true,
      codeStatus2: false,
      formStatus3: true,
      codeStatus3: false,

      formStatus5: true,

      labelStatus: true,
      editStatus: false,

      requestIndex: 0,

      paramBlank: [0, 0, 0, 0],
      paramEmpty: [0, 0, 0, 0],
    };
  },
  methods: {
    switchView: function (num) {
      switch (num) {
        case 0:
          this.formStatus0 = !this.formStatus0;
          this.codeStatus0 = !this.codeStatus0;
          break;
        case 1:
          this.formStatus1 = !this.formStatus1;
          this.codeStatus1 = !this.codeStatus1;
          break;
        case 2:
          this.formStatus2 = !this.formStatus2;
          this.codeStatus2 = !this.codeStatus2;
          break;
        case 3:
          this.formStatus3 = !this.formStatus3;
          this.codeStatus3 = !this.codeStatus3;
          break;
        case 5:
          this.formStatus5 = !this.formStatus5;
          break;
      }

      // this.formStatus = !this.formStatus
      // this.codeStatus = !this.codeStatus+num
    },
    connectionLabelForm: function () {
      this.labelStatus = !this.labelStatus;
      this.editStatus = !this.editStatus;
    },
    deleteInputs: function () {
      console.log("원래는 초기화 시켜야 하는데 그냥 사라지네?");
    },
    submitBtn() {
      eventbus.$emit("getInputsData");

      console.log(
        "전체:",
        JSON.parse(this.$store.state.devStore.configureData[0].form)
      );

      console.log("params:", this.$store.state.devStore.paramMap);

      // console.log(this.$store.state.devStore.paramMap)

      var form = JSON.parse(this.$store.state.devStore.configureData[0].form);

      for (var b = 0; b < form.length; b++) {
        var paramList = new Map();
        if (this.$store.state.devStore.paramMap[b] != undefined) {
          // for(var i = 0; i < this.$store.state.devStore.paramMap[this.requestIndex].length; i++){
          // console.log(this.$store.state.devStore.paramMap[this.requestIndex][i])
          paramList = this.$store.state.devStore.paramMap[b];
          // }
        }

        console.log(paramList);

        var headerList = new Map();

        if (this.$store.state.devStore.headerMap[b] != undefined) {
          //     for(var j = 0; j < this.$store.state.devStore.headerMap[this.requestIndex].length; j++){
          //         console.log(this.$store.state.devStore.headerMap[this.requestIndex][j])
          headerList = this.$store.state.devStore.headerMap[b];
          //     }
        }

        var bodyList = new Map();
        if (this.$store.state.devStore.bodyMap[b] != undefined) {
          //     for(var j = 0; j < this.$store.state.devStore.headerMap[this.requestIndex].length; j++){
          //         console.log(this.$store.state.devStore.headerMap[this.requestIndex][j])
          bodyList = this.$store.state.devStore.bodyMap[b];
          //     }
        }
        //     // console.log(form[b].urlParam)
        //     // console.log(JSON.parse(this.$store.state.devStore.configureData[0].form)[i].urlParam)
        //     console.log("ma:", this.$store.state.devStore.paramMap[b])

        form[b].urlParam = Object.fromEntries(paramList);
        form[b].header = Object.fromEntries(headerList);
        form[b].requestBody = Object.fromEntries(bodyList);
        form[b].autoEmptyParam = this.paramEmpty[b];
        form[b].autoBlankParamDelete = this.paramBlank[b];
      }

      console.log("form:", form);

      this.$store.state.devStore.configureData[0].form = form;

      var param = {
        appCode: this.$store.state.devStore.appCode,
        apiCode: this.$store.state.devStore.apiCode,

        checkType: this.$store.state.devStore.apiData.apiName,
        where: "request",

        apiSchema: JSON.stringify(this.$store.state.devStore.configureData),
      };

      this.api.configSchema(param)
        .then((res) => {
          console.log("저장 : ", res);

          // this.$store.dispatch("selectFields").then(() => {
          //   // this.$router.push({
          //   // name: "DevAuthSettings",
          //   // params: {
          //   // },
          //   // });
          // });
        })
        .catch(() => alert("오류가 발생했습니다. auth 2"));
    },
  },

  mounted() {},
  created() {
    this.$store.state.devStore.paramMap = [[], [], [], []];
    this.$store.state.devStore.headerMap = [[], [], [], []];
    this.$store.state.devStore.bodyMap = [[], [], [], []];

    eventbus.$on("method", (res, num) => {
      console.log("메소드: ", res, num);

      var form = JSON.parse(this.$store.state.devStore.configureData[0].form);
      form[num].method = res.method;
      form[num].url = res.url;

      this.$store.state.devStore.configureData[0].form = JSON.stringify(form);

      console.log("전체:", this.$store.state.devStore.configureData[0].form);
    });

    eventbus.$on("omitDatas", (res) => {
      console.log(res);

      var count = res[2];

      this.paramEmpty[count] = res[0];
      this.paramBlank[count] = res[0];

      console.log(this.paramBlank, this.paramEmpty);
    });

    console.log(" 배열에 값이 잘 들어가는지 확인을 하는 부분");
    console.log(this.$store.state.devStore.paramMap);

    for (var n = 0; n < 4; n++) {
      this.requestIndex = n;

      if (
        Object.keys(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[
            this.requestIndex
          ].urlParam
        ).length > 0
      ) {
        var inin = new Array();

        for (
          var i = 0;
          i <
          Object.keys(
            JSON.parse(this.$store.state.devStore.configureData[0].form)[
              this.requestIndex
            ].urlParam
          ).length;
          i++
        ) {
          var data = new Object();
          data.keys = Object.keys(
            JSON.parse(this.$store.state.devStore.configureData[0].form)[
              this.requestIndex
            ].urlParam
          )[i];
          data.values = Object.values(
            JSON.parse(this.$store.state.devStore.configureData[0].form)[
              this.requestIndex
            ].urlParam
          )[i];
          inin.push(data);
        }

        // this.inputs = inin
        this.$store.state.devStore.paramMap[this.requestIndex] = inin;

        // console.log( "param parma : ", this.$store.state.devStore.paramMap[0])
      }

      if (
        Object.keys(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[
            this.requestIndex
          ].header
        ).length > 0
      ) {
        var inin1 = new Array();

        for (
          var j = 0;
          j <
          Object.keys(
            JSON.parse(this.$store.state.devStore.configureData[0].form)[
              this.requestIndex
            ].header
          ).length;
          j++
        ) {
          data = new Object();
          data.keys = Object.keys(
            JSON.parse(this.$store.state.devStore.configureData[0].form)[
              this.requestIndex
            ].header
          )[j];
          data.values = Object.values(
            JSON.parse(this.$store.state.devStore.configureData[0].form)[
              this.requestIndex
            ].header
          )[j];
          inin1.push(data);
        }

        // this.inputs = inin
        this.$store.state.devStore.headerMap[this.requestIndex] = inin1;

        // console.log( "param parma : ", this.$store.state.devStore.headerMap[0])
      }

      if (
        Object.keys(
          JSON.parse(this.$store.state.devStore.configureData[0].form)[
            this.requestIndex
          ].requestBody
        ).length > 0
      ) {
        var inin2 = new Array();
        for (
          var k = 0;
          k <
          Object.keys(
            JSON.parse(this.$store.state.devStore.configureData[0].form)[
              this.requestIndex
            ].requestBody
          ).length;
          k++
        ) {
          data = new Object();
          data.keys = Object.keys(
            JSON.parse(this.$store.state.devStore.configureData[0].form)[
              this.requestIndex
            ].requestBody
          )[k];
          data.values = Object.values(
            JSON.parse(this.$store.state.devStore.configureData[0].form)[
              this.requestIndex
            ].requestBody
          )[k];
          inin2.push(data);
        }

        // this.inputs = inin
        this.$store.state.devStore.bodyMap[this.requestIndex] = inin2;

        // console.log( "param parma : ", this.$store.state.devStore.bodyMap[0])
      }
    }
    console.log(" 배열에 값이 잘 들어가는지 확인을 하는 부분2");
    console.log(this.$store.state.devStore.paramMap);
  },
};
</script>
